import React from 'react';
import styled from 'styled-components';

const FooterGroup = styled.div`
    padding: 50px 0px;
    display: grid;
    grid-gap: 5px;
`

const Text = styled.p`
    font-size: 12px;
    font-weight: 300;
    color: rgba(255,255,255,0.5);
    max-width: 500px;
    margin: 0 auto;
`

const Footer = (props) => (
    <FooterGroup>
        <Text>Designed & Built by Mary Quan</Text>
        <Text>mquan.io © 2021</Text>
    </FooterGroup>
);

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js